import { User, UserReference } from '../../admin/admin.types';
import { CandidateReference } from '../../candidate/candidate.types';
import { Guest, GuestReference } from '../../note/note.types';
import { OfferBrief, OfferItemReference } from '../../offer/offer.types';
import { QuestionKind, QuestionOptions } from '../../question/question.types';
import { Stage, StageReference } from '../../stage/stage.types';

export type Admin = {
  type: string;
  photoThumbUrl: string;
  lastName: string;
  id: number;
  firstName: string;
  initials: string;
  hasAvatar: boolean;

  name: string;
};

export enum RatingLevel {
  No = 'no',
  Neutral = 'neutral',
  Yes = 'yes',
  StrongYes = 'strong_yes',
}

export type RatingLevelTranslations = Record<RatingLevel, string>;

export type RatingLevelType = `${RatingLevel}`;

export type Params = {
  candidateId?: number;
  limit?: number;
  page?: number;
  scope?: string;
  adminIds?: number[] | null;
  status?: string;
};
export type InterviewResultAnswerOption = { hint: string; title: string };

export type InterviewResultAnswer = {
  content?: string;
  contents?: string[];
  id: number;
  flag?: boolean;
  questionHint: string;
  questionKind: QuestionKind;
  questionRequired: boolean;
  questionTitle: null | string;
  attachmentIds?: number[];
  attachments?: any[];
  options?: InterviewResultAnswerOption[];
  questionOptions?: QuestionOptions;
};

export type InterviewResult = {
  admin: Admin | User;
  adminId: number;
  candidate: any;
  candidateId: number;
  createdAt: string;
  guestId: number;
  id: number;
  interviewResultAnswers: InterviewResultAnswer[];
  interviewResultRequestId?: number;
  interviewTemplateName: string;
  kind: string;
  offer?: OfferBrief;
  offerId: number | null;
  rating: RatingLevelType;
  ratingNote: null | string;
  ratingRequired?: boolean;
  guest?: Guest;
  stage?: Stage;
  stageId: number | string;
  updatedAt: string;
};

export type HiddenResultPreview = {
  count: number;
  admins: Admin[];
  guests?: Guest[];
  offer: OfferBrief;
  stage: Stage;
  offerId: number;
  stageId: number | null;
  updatedAt: string;
  guestIds: number[];
  adminIds: number[];
  candidateId: number;
  id: string;
};

export type InterviewResultCollection = {
  requests: InterviewResult[];
  hiddenResultsPreview: HiddenResultPreview[];
  counters: InterviewResultCounters;
};

export enum InterviewGroupBy {
  STATUS = 'status',
  STAGE = 'stage',
  MEMBER = 'member',
  FORM = 'form',
}

export type HiddenInterviewResult = InterviewResult & { hidden?: boolean };

export interface InterviewResultCounters {
  completed: number;
  dismissed: number;
  pending: number;
}

export interface InterviewResultMeta {
  counters: InterviewResultCounters;
}

export interface InterviewResultResponse {
  requests: InterviewResult[];
  hiddenResultsPreview: HiddenResultPreview[];
}

export interface InterviewResultResponseSingle {
  interviewResult: InterviewResult;
}

export interface InterviewResultResponseWithMeta extends InterviewResultResponse {
  meta: InterviewResultMeta;
}

export type InterviewResultsReferences =
  | GuestReference
  | UserReference
  | CandidateReference
  | OfferItemReference
  | StageReference;
export type InterviewReferences = { references: InterviewResultsReferences[] };

export interface GroupedInterviewResult {
  items: InterviewResult[];
  title: string | null;
  rating: number | null;
  offer?: OfferBrief | null;
  position?: string;
  hiddenResultsPreview?: HiddenResultPreview[];
}
